export function mapValues<V, K extends string | number | symbol, R>(
  obj: Record<K, V>,
  fn: (value: V, key: K) => R,
) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, fn(value as V, key as K)]),
  );
}
